export const API_BASE_PATH = process.env.API_BASE_PATH || '';

export const API_PAYMENT_CONFIGURATION = `${API_BASE_PATH}/payment-configuration-service/public`;
export const API_PAYMENT_BOOT_SERVICE_REQUESTED_LIMITS = `${API_BASE_PATH}/requestedlimits/public`;

export const PFDS = '/PaymentFormDataService/rest';
export const API_PFDS = `${API_BASE_PATH}${PFDS}`;
